// https://www.npmjs.com/package/xlsx
import XLSX from 'xlsx'

const mergeDataWithColumns = function (data, columns) {
    const table = []
    let tempRow

    if (columns) {
      data.forEach(row => {
        tempRow = {}
        columns.forEach(({ key }) => {
          // if (display) {
            tempRow[key] = row[key]
          // }
        })
        table.push(tempRow)
      })
      return table
    }
    return data
  }

  const exportToExcel = function (fileName, columns, data) {
    if (data.length === 0) {
        columns = null
    }
    var excelDate = mergeDataWithColumns(data, columns)
    const ws = XLSX.utils.json_to_sheet(excelDate)
    if (columns) {
        columns.forEach(({ cell, title }) => {
        // if (display) {
                ws[cell].v = title
            // }
        })
    }

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'data')
    XLSX.writeFile(wb, `${fileName}.xlsx`)
}

export { exportToExcel }
